module.exports = __webpack_public_path__ + "static/silicane-7ed0e4f9d8118981839014d9a0251f7e.png";